const Redirect = (url: any) => {
    window.location.href = url;
};

export default Redirect;